// Re-exports of global, non-themed assets. Importing through this barrel
// keeps consumer code stable if a file is renamed or hashed differently.
import placeholderProduct from './placeholder-product.svg';
import ogImage from './og-image.svg';
import restaurantDefaultImage from './restaurant-default-dish.jpg';
import restaurantPromoDefault from './restaurant-promo-default.jpg';
import restaurantHero1 from './restaurant-hero/hero-1.jpg';
import restaurantHero2 from './restaurant-hero/hero-2.jpg';
import restaurantHero3 from './restaurant-hero/hero-3.jpg';
import restaurantBentoWide from './restaurant-bento/wide.jpg';
import restaurantBentoLeft from './restaurant-bento/left.jpg';
import restaurantBentoCenter from './restaurant-bento/center.jpg';
import restaurantBentoTall from './restaurant-bento/tall.jpg';

export const assets = {
  placeholderProduct,
  ogImage,
  restaurantDefaultImage,
  // Default home promo banner photo (copy is overlaid by the page).
  restaurantPromoDefault,
  // Default home hero slides, until the merchant uploads hero banners.
  restaurantHeroSlides: [restaurantHero1, restaurantHero2, restaurantHero3],
  // Default promo bento tiles (wide top-left, two small, tall right), shown
  // until the merchant uploads theme_settings.sub_banners.
  restaurantBento: [
    restaurantBentoWide,
    restaurantBentoLeft,
    restaurantBentoCenter,
    restaurantBentoTall,
  ],
};
